// libraries and utilities
import { put, call, takeEvery } from "redux-saga/effects";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { apiGet, BASE_URL, objectToParams, retrieveToken } from "../../store/api";
import { StatusKerjasamaListResponse } from "./types";

import * as statusKerjasamaActions from "./statusKerjasama.actions";

export function* getStatusKerjasama(
  action: ReturnType<typeof statusKerjasamaActions.getStatusKerjasamaAsync.request>
) {
  try {
    const payload = { status: action.payload.status };
    if (typeof action.payload.status === 'undefined') delete payload.status;
    
    const token: string = yield retrieveToken();
    const url = `${BASE_URL}status-kerjasama${objectToParams(payload)}`;
    const result: Response = yield call(apiGet, url, token);

    if (result.status === 200) {
      const parsed: StatusKerjasamaListResponse = yield call(result.json.bind(result));
      yield put(statusKerjasamaActions.getStatusKerjasamaAsync.success(parsed));
      return; 
    } else {
      const parsed: ErrorResponse = yield call(result.json.bind(result));
      yield put(statusKerjasamaActions.getStatusKerjasamaAsync.failure(parsed));
      return;
    }
  } catch (err) {
    const parsed: ErrorResponse = {
      name: 'Internal server error',
      message: 'Internal server error',
      code: 500,
      status: 500
    }
    yield put(statusKerjasamaActions.getStatusKerjasamaAsync.failure(parsed));
  }
}

export default function* statusKerjasamaSagaGetStatusKerjasama() {
  yield takeEvery(statusKerjasamaActions.getStatusKerjasamaAsync.request, getStatusKerjasama);
}
